import { render } from "./editOrganization.vue?vue&type=template&id=3d8a1afe&scoped=true"
import script from "./editOrganization.vue?vue&type=script&lang=js"
export * from "./editOrganization.vue?vue&type=script&lang=js"

import "./editOrganization.vue?vue&type=style&index=0&id=3d8a1afe&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d8a1afe"]])

export default __exports__